import React from 'react';
import classnames from 'classnames';
import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';

import { MMAPlacementCard, PlacementHeadline, PlacementDescription, BusinessNameWithLogo, BusinessNameWithChoiceIcon } from '../../shared-components';

export const AdPlacementMmaBaseV2 = ({
  placementData, // UAPVMSingleImagePlacement
  isEnabled,

  showShortHeadline,
  shortHeadline,
  isMultiLineShortHeadline,
  showSmallSizeHeadline,

  showLongHeadline,
  longHeadline,
  isMultiLineLongHeadline,

  finalUrl,

  showDescription,
  description,
  isMultiLineDescription,

  showCallToAction,
  callToAction,

  businessName,
  showBusinessNameWithLogoTop,
  showLogo,
  logo,

  showAdChoiceIconArea,
  showBusinessNameInAdChoiceArea,
  showAdIcon,
  showChoiceIcon,
  showCallToActionAsLink,
  showBrightStyleChoiceIcon,

  i18n, // may need to set window._TL_ in other platforms
  classes,
  showGradient,
  customizedComponent: CustomizedComponent,
}) => {
  const {
    placementMeta, placementCropping, imageMeta, effectiveImageUrl, effectiveImageWidth, effectiveImageHeight, expandedPlacementCropping,
  } = placementData || {};
  const {
    previewHeight, aspectRatio, logoHeight, imageBorderRadius,
  } = placementMeta || {};

  // const srcForCroppedImageView = showImage && this.props.image.FinalSrc;
  const imagePreviewWidth = previewHeight * aspectRatio;

  if (!placementData || !imageMeta) {
    return null;
  }

  const cropping = expandedPlacementCropping || placementCropping;

  return (
    <MMAPlacementCard url={finalUrl} width={imagePreviewWidth} isEnabled={isEnabled} mmaPlacementCardClassName={classes.placementCard} isAdPreviewRefreshEnabled>
      <div className={classnames(classes.placementImageContainer)}>
        {
          imageMeta.url &&
          <CroppedImageView
            resizeImageHeight={previewHeight}
            aspectRatio={aspectRatio}
            src={effectiveImageUrl || imageMeta.url}
            originalWidth={effectiveImageWidth || imageMeta.originalWidth}
            originalHeight={effectiveImageHeight || imageMeta.originalHeight}
            SourceX={cropping && cropping.SourceX}
            SourceY={cropping && cropping.SourceY}
            SourceWidth={cropping && cropping.SourceWidth}
            SourceHeight={cropping && cropping.SourceHeight}
            borderRadius={imageBorderRadius}
          />
        }
      </div>
      <div className={classnames(classes.placementTextContainer)}>
        {showGradient && <div className={classes.placementGradient} />}
        <div className={classnames(classes.placementInfoContainer)}>
          {showBusinessNameWithLogoTop && (
            <BusinessNameWithLogo
              businessName={businessName}
              showLogo={showLogo}
              logo={logo}
              logoHeight={logoHeight}
              classes={classes}
            />
          )}
          {showShortHeadline && (
            <PlacementHeadline
              headlineText={shortHeadline}
              isMultiLine={isMultiLineShortHeadline}
              placementHeadlineClassName={classnames(classes.placementShortHeadline, showSmallSizeHeadline && classes.smallSizeHeadline, 'short-headline')}
            />
          )}
          {showLongHeadline && (
            <PlacementHeadline
              headlineText={longHeadline}
              isMultiLine={isMultiLineLongHeadline}
              placementHeadlineClassName={classnames(classes.placementLongHeadline, showSmallSizeHeadline && classes.smallSizeHeadline, 'long-headline')}
            />
          )}
          {showDescription && (
            <PlacementDescription
              description={description}
              isMultiLine={isMultiLineDescription}
              placementDescriptionClassName={classnames(classes.placementDescription, 'description')}
            />
          )}
        </div>
        {showAdChoiceIconArea && (
          <BusinessNameWithChoiceIcon
            i18n={i18n}
            classes={classes}
            businessName={businessName}
            showBusinessName={showBusinessNameInAdChoiceArea}
            showAdIcon={showAdIcon}
            showChoiceIcon={showChoiceIcon}
            showCallToAction={showCallToAction}
            callToAction={callToAction}
            showCallToActionAsLink={showCallToActionAsLink}
            showBrightStyleChoiceIcon={showBrightStyleChoiceIcon}
          />
        )}
      </div>
      {CustomizedComponent && <CustomizedComponent customizedClassName={classes.customizedArea} />}
    </MMAPlacementCard>
  );
};
